import Help from '../views/Help'

// todo (h2): interface, and how to get the data?
export const HelpContainer = () => {
  return (
    <Help
      faqLink={'/faqs'}
      contactPhone={'1-646-396-0926'}
      contactEmail={'ritualforbuildings@ritual.co'}
    />
  )
}
